import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertCircle, X } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Sprint 34.9 — site-wide banners loaded from /api/banners. Polls every 60s.
 * Severities map to color classes; closeable until next reload.
 */
export default function MaintenanceBanner() {
  const [banners, setBanners] = useState([]);
  const [dismissed, setDismissed] = useState(new Set());

  useEffect(() => {
    let mounted = true;
    const fetchBanners = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/banners`);
        if (mounted) setBanners(Array.isArray(data) ? data : []);
      } catch { /* silent */ }
    };
    fetchBanners();
    const t = setInterval(fetchBanners, 60000);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  const visible = banners.filter(b => !dismissed.has(b.id));
  if (visible.length === 0) return null;

  const bgFor = (sev) => ({
    info: 'bg-aura-purple/20 text-aura-purple border-aura-purple/30',
    warning: 'bg-aura-gold/20 text-aura-gold border-aura-gold/30',
    error: 'bg-error/20 text-error border-error/30',
  }[sev] || 'bg-aura-purple/20 text-aura-purple border-aura-purple/30');

  return (
    <div className="sticky top-0 z-[90] space-y-px">
      {visible.map(b => (
        <div key={b.id} className={`border-b px-4 py-2 flex items-center justify-center gap-3 text-xs sm:text-sm ${bgFor(b.severity)}`}>
          <AlertCircle className="w-4 h-4 shrink-0" />
          <span className="flex-1 text-center">{b.message}</span>
          <button
            onClick={() => setDismissed(s => new Set([...s, b.id]))}
            className="opacity-60 hover:opacity-100 p-2.5 min-w-[44px] min-h-[44px] flex items-center justify-center"
            aria-label="Dismiss banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
